import "core-js/modules/es6.function.name";
import React, { isValidElement } from 'react';
import isEmpty from 'lodash/isEmpty';
import domToReact from 'html-react-parser/lib/dom-to-react';
import ndsLib from './nds-lib';

var nodeToNDSComponent = function nodeToNDSComponent(componentDict) {
  var forceWhitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (node) {
    if (isEmpty(node.name)) {
      return node.data;
    } // Since the children have already been convereted to DOM nodes,
    // we need to use domToReact to transform them


    var childrenTransformed = !isEmpty(node.children) ? domToReact(node.children, {
      replace: nodeToNDSComponent(componentDict)
    }) : node.data;
    var nodeName = String(node.name); // We need to find a transformer for the node un the custom library first

    var NDSTransformer;

    if (forceWhitelist) {
      NDSTransformer = componentDict[nodeName] || componentDict.generic || ndsLib.generic;
    } else {
      NDSTransformer = componentDict[nodeName] || ndsLib[nodeName] || componentDict.generic || ndsLib.generic;
    }

    var NDSElement = NDSTransformer(node, childrenTransformed); // We need to make sure the transformer returns a react element, otherwise,
    // the replace won't work

    return isValidElement(NDSElement) ? NDSElement : React.createElement("span", null, NDSElement);
  };
};

export default nodeToNDSComponent;